"use client";
import { activeSiteConfig } from "@config/site/site-config";
import { CookieConsentCategory, CookieConsentStatus } from "@lib/analytics/cookieConsent";
import { CookieConsentScript } from "@lib/analytics/CookieConsentScript";
import { GtmScript } from "@lib/analytics/GtmScript";
import { useCookieConsent } from "@lib/analytics/useCookieConsent";
import type { FeatureFlags } from "@lib/feature-flags/types";
import dynamic from "next/dynamic";

import { useDeferredScripts } from "./useDeferredScripts";

const KlarnaSiteMessaging = dynamic(() => import("@lib/analytics/KlarnaSiteMessaging"), {
    ssr: false,
});
const BazaarvoiceScript = dynamic(() => import("@lib/analytics/BazaarvoiceScript"), {
    ssr: false,
});
const GrabPayWidgetScript = dynamic(() => import("../analytics/GrabPayWidgetScript"), {
    ssr: false,
});
const BloomreachScript = dynamic(() => import("@lib/analytics/BloomreachScript"), {
    ssr: false,
});

const GlobalScripts = ({
    locale,
    featureFlags,
}: {
    locale: string;
    featureFlags: FeatureFlags;
}) => {
    const { isBloomreachEnabled, isGtmEnabled, isCookieConsentEnabled, isBazaarVoiceEnabled } =
        featureFlags ?? {};

    const deferredReady = useDeferredScripts();
    const marketingConsent = useCookieConsent(CookieConsentCategory.MARKETING);
    const shouldLoadBloomreach =
        deferredReady &&
        isBloomreachEnabled?.enabled === true &&
        marketingConsent === CookieConsentStatus.GRANTED;

    return (
        <>
            {isCookieConsentEnabled?.enabled && <CookieConsentScript locale={locale} />}
            {isGtmEnabled?.enabled && <GtmScript />}
            {deferredReady && (
                <>
                    {activeSiteConfig?.onKlarnaSiteMessaging && <KlarnaSiteMessaging />}
                    {isBazaarVoiceEnabled?.enabled && <BazaarvoiceScript />}
                    {activeSiteConfig?.hasGrabPayWidget && <GrabPayWidgetScript />}
                </>
            )}
            {shouldLoadBloomreach && <BloomreachScript />}
        </>
    );
};

export default GlobalScripts;
